export default "__VITE_ASSET__BZckW6Oo__"